import { ApolloClient, InMemoryCache } from '@apollo/client';

import { GLOSS } from '~/constants';
import preloaded from '~/preloaded';

const client = new ApolloClient({
  uri: `${preloaded.urls.vortex}${GLOSS}`,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export default client;
